













import { Component, Vue } from "vue-property-decorator";
import toolbar from "./components/toolbar.vue";
import itemlist from "./components/itemlist.vue";
import inputbox from "./components/inputbox.vue";
declare module "vue/types/vue" {
  interface Vue {
    [key: string]: any;
  }
}
@Component({
  components: { toolbar, itemlist, inputbox },
})
export default class App extends Vue {
  public article: Array<object> = this.$store.state.remoteHelper.articles;
}
